import React, { useEffect, useState } from "react";

import { ReactComponent as Logo } from "../assets/images/logo.svg";
import { OutboundLink } from "./OutboundLink";
import { HEADLINE_REVEAL_MS } from "./IntroAnimation";
import { SocialButton } from "./SocialShareButtons";
import { FooterAttribution } from "./Attribution";

const DONATION_LINK =
  "https://donorbox.org/nycdonate?utm_source=button&utm_medium=website&utm_campaign=2026%20street%20arrests%20article";

const Header = () => {
  const [showHeaderLinks, setShowHeaderLinkse] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowHeaderLinkse(true), HEADLINE_REVEAL_MS);
  }, []);

  return (
    <nav className="nav">
      <div
        className="nav-container"
        style={{
          opacity: showHeaderLinks ? 1 : 0,
          pointerEvents: showHeaderLinks ? "auto" : "none",
          transition: "opacity 1200ms ease",
        }}
      >
        <div className="nav-logo">
          <OutboundLink
            to="https://thecityreporter.nyc/"
            aria-label="The City Reporter"
          >
            <Logo />
          </OutboundLink>
        </div>
        <div className="nav-title"></div>
        <div className="nav-links">
          <OutboundLink to={DONATION_LINK}>Donate</OutboundLink>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer mt-6">
      <div className="container">
        <div className="eyebrow has-text-centered has-text-weight-light mb-5">
          Made with ♥ in NYC by{" "}
          <OutboundLink to="https://www.thecityreporter.nyc">
            The City Reporter
          </OutboundLink>
        </div>
        <div className="has-text-centered">
          <SocialButton
            url="https://x.com/thecityny"
            ariaLabel="The City Reporter on X (formerly Twitter)"
            customSize="2rem"
          />
          <SocialButton
            url="https://bsky.app/profile/thecityreporter.nyc"
            ariaLabel="The City Reporter on Bluesky"
            customSize="2rem"
          />
          <SocialButton
            url="https://www.facebook.com/thecityny"
            ariaLabel="The City Reporter on Facebook"
            customSize="2rem"
          />
          <SocialButton
            url="https://www.instagram.com/thecityny/"
            ariaLabel="The City Reporter on Instagram"
            customSize="2rem"
          />
          <SocialButton
            url="https://www.thecityreporter.nyc"
            ariaLabel="The City Reporter on their Website"
            customSize="2rem"
          />
        </div>
        <div
          className="eyebrow has-text-centered has-text-weight-light mt-5"
          style={{ maxWidth: "725px", margin: "1.5rem auto 0 auto" }}
        >
          <FooterAttribution />
        </div>
        <div
          className="eyebrow has-text-centered has-text-weight-light mt-5"
          style={{ maxWidth: "725px", margin: "1.5rem auto 0 auto" }}
        >
          This investigation was supported by a grant from{" "}
          <OutboundLink to="https://datadrivenreporting.medill.northwestern.edu/">
            The Data-Driven Reporting Project
          </OutboundLink>{" "}
          at Northwestern University’s Medill School of Journalism and support
          from the{" "}
          <OutboundLink to="https://fij.org/">
            Fund for Investigative Journalism
          </OutboundLink>
          .
        </div>
        <div
          className="eyebrow has-text-centered has-text-weight-light mt-5"
          style={{ maxWidth: "725px", margin: "1.5rem auto 0 auto" }}
        >
          <OutboundLink to="https://www.thecityreporter.nyc/2026/05/27/street-arrests-immigration-methodology-habeas-petitions/">
            Read more about how The City Reporter compiled its ICE arrest
            database
          </OutboundLink>{" "}
          and why we are confident about our findings.
        </div>
        <ul className="eyebrow footer-links my-4 has-text-weight-light">
          <li className="mx-3 my-1">
            <OutboundLink to="https://www.thecityreporter.nyc/about-us/">
              About
            </OutboundLink>
          </li>
          <li className="mx-3 my-1">
            <OutboundLink to={DONATION_LINK}>Donate</OutboundLink>
          </li>
          <li className="mx-3 my-1">
            <OutboundLink to="https://www.thecityreporter.nyc/team/">
              Team
            </OutboundLink>
          </li>
          <li className="mx-3 my-1">
            <OutboundLink to="https://www.thecityreporter.nyc/funders/">
              Funders
            </OutboundLink>
          </li>
          <li className="mx-3 my-1">
            <OutboundLink to="https://www.thecityreporter.nyc/ethics/">
              Ethics
            </OutboundLink>
          </li>
          <li className="mx-3 my-1">
            <OutboundLink to="https://www.thecityreporter.nyc/republishing/">
              Republish
            </OutboundLink>
          </li>
          <br />
          <li className="mx-3 my-1">
            <OutboundLink to="https://www.thecityreporter.nyc/contact/">
              Contact
            </OutboundLink>
          </li>
          <li className="mx-3 my-1">
            <OutboundLink to="https://www.thecityreporter.nyc/privacy-policy/">
              Privacy Notice
            </OutboundLink>
          </li>
        </ul>
        <div className="copyright has-text-weight-light">
          © {year}, THE CITY REPORT, INC. All Rights Reserved.{" "}
        </div>
      </div>
    </footer>
  );
};

export const PageLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <article>
    <Header />
    {children}
    <Footer />
  </article>
);
